@let ticket = result();

<div
  (click)="openTicket(ticket.id)"
  class="relative flex items-center justify-center gap-2 w-full hover:bg-hover cursor-pointer group rounded-md"
>
  <span
    class="flex items-center justify-center rounded-md min-w-8 min-h-8 text-center content-center bg-surface-tertiary group-hover:bg-surface-quaternary"
  >
    <soft-icon name="fa-regular fa-comment" class="text-sm"></soft-icon>
  </span>
  <div class="flex flex-row w-full text-start set-width">
    <span class="text-sm font-semibold text-start"
      >{{ticket.id}}: {{ ticket.name | translate }}</span
    >
  </div>
</div>
